<template>
	<div class="flex flex-row space-x-3 mx-auto w-auto">
		<div v-for="index in props.total_steps" :key="index" class="flex relative items-center text-center">
			<img v-if="index < props.current_step" src="@/assets/images/icon/step-indicator-completed.svg" alt="Completed" title="Completed" />
			<img v-else-if="index === props.current_step" src="@/assets/images/icon/step-indicator-filled.svg" alt="Current" title="Current" />
			<img v-else src="@/assets/images/icon/step-indicator-empty.svg" alt="Incomplete" title="Incomplete"/>
			<p v-if="index === props.current_step" class="absolute w-full text-label-on-color font-medium">{{ index }}</p>
			<p v-else-if="index > props.current_step" class="absolute w-full text-primary font-medium">{{ index }}</p>
		</div>
	</div>
</template>

<script setup lang="js">

const props = defineProps(
	{
		current_step: { default: 1 },
		total_steps: { default: 4 }
	})

</script>
